<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="printAllButtonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile
                @click="
                  printAllMonthlyAnalysisReportByCity(
                    'printAllMonthlyReportByCity'
                  )
                "
              >
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                ref="fromMenu"
                v-model="fromMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="queryParams.fromDate"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="queryParams.fromDate"
                    label="From Month"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="queryParams.fromDate"
                  type="month"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="fromMenu = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    flat
                    color="primary"
                    @click="$refs.fromMenu.save(queryParams.fromDate)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                ref="toMenu"
                v-model="toMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="queryParams.toDate"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="queryParams.toDate"
                    label="To Month"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="queryParams.toDate"
                  type="month"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="toMenu = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    flat
                    color="primary"
                    @click="$refs.toMenu.save(queryParams.toDate)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.productIds"
                :items="selectedProductList"
                label="Product"
                @click="showProducts()"
                item-text="code"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                :items="cityList"
                label="City"
                v-model="queryParams.cityIds"
                item-text="name"
                item-value="id"
                menu-props="auto"
                multiple
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.categoryIds"
                :items="categoryList"
                label="Category"
                item-text="name"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3 v-if="user.role.roleName != 'GENERAL_MANAGER'">
              <v-select
                :items="shopList"
                label="Choose Shop..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                v-model="queryParams.shopId"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="monthlyStockAnalysisReportList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.cityName }}</td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.date }}</td>
              <td>{{ props.item.qty | decFormat(6) }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!--Product List dialog-->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="productQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="productQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand"
                type="text"
                class="mr-1"
                v-model="productQueryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category"
                type="text"
                class="mr-1"
                v-model="productQueryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group"
                type="text"
                class="mr-1"
                v-model="productQueryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchProduct">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                v-model="selectedProductList"
                :headers="productHeaders"
                :items="productList"
                select-all
                class="elevation-1"
                :loading="showListLoading"
                :total-items="productTotalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="productPagination"
                :must-sort="true"
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th>
                      <v-checkbox
                        primary
                        hide-details
                        @click.native="toggleAllProduct"
                        :input-value="props.all"
                        :indeterminate="props.indeterminate"
                      ></v-checkbox>
                    </th>
                    <th v-for="header in props.headers" :key="header.text">
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <td>
                    <v-checkbox
                      primary
                      hide-details
                      :input-value="props.selected"
                      :value="props.item"
                      :indeterminate="props.indeterminate"
                      v-model="selectedProductList"
                      multiple
                    ></v-checkbox>
                  </td>
                  <td>
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.brand.name }}</td>
                  <td>{{ props.item.category.name }}</td>
                  <td v-if="props.item.productGroup">
                    {{ props.item.productGroup.name }}
                  </td>
                  <td v-else></td>
                  <td>{{ props.item.description }}</td>
                </template>
              </v-data-table>
              <div class="text-xs-right">
                <v-btn color="primary" @click="setProduct">Ok</v-btn>
              </div>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--print all-->
    <div
      id="printAllMonthlyReportByCity"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">
          Monthly Product Sale Report By City
        </p>
      </div>
      <br />
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 1px">
          Category : {{ filterCategory }}
        </p>
      </div>
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">
                City Name
              </th>
              <th style="border: 1px solid black; text-align: center">
                Stock No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Stock Name
              </th>
              <th style="border: 1px solid black; text-align: center">Qty</th>
            </tr>
          </thead>
          <tbody
            v-for="(
              monthlyStockAnalysisReport, index
            ) in allMonthlyStockAnalysisReportByCityList"
            :key="index"
          >
            <tr
              v-for="(
                item, i
              ) in monthlyStockAnalysisReport.monthlyStockAnalysisReports"
              :key="i"
            >
              <td
                v-if="i == 0"
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
                v-bind:rowspan="
                  monthlyStockAnalysisReport.monthlyStockAnalysisReports.length
                "
              >
                {{ item.cityName }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.code }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.name }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.qty | decFormat(6) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { productService } from "../../services/product-service";
import { commonService } from "../../services/common-service";
import { cityService } from "../../services/city-service";
import { stockService } from "../../services/stock-service";
import { categoryService } from "../../services/category-service";
import { shopService } from "../../services/shop-service";

export default {
  name: "MonthlyProductSaleReportByCity",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showFilters: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Sale Reports",
        disabled: true,
      },
      {
        text: "Monthly Product Sale Report By City",
        disabled: true,
      },
    ],
    headers: [
      { text: "City Name", align: "left", sortable: false },
      { text: "Product Code", align: "left", sortable: false },
      { text: "Product Name", align: "left", sortable: false },
      { text: "Date", align: "left", sortable: false },
      { text: "Qty", align: "left", sortable: false },
    ],
    productHeaders: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" },
    ],
    queryParams: {
      fromDate: new Date().toISOString().substr(0, 7),
      toDate: new Date().toISOString().substr(0, 7),
      productIds: [],
      cityIds: [],
      categoryIds: [],
      shopId: "",
    },
    productQueryParams: {
      productName: "",
      productCode: "",
      brandName: "",
      categoryName: "",
      productGroupName: "",
      status: "ACTIVE",
    },
    productPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "null",
      totalItems: 0,
    },
    rowsPerPageItems: [25, 50, 100],
    productTotalRows: 0,
    totalRows: 0,
    grandTotalQty: 0,
    valid: true,
    fromMenu: false,
    toMenu: false,
    showProductListDialog: false,
    showListLoading: false,
    printAllButtonLoading: false,
    selectedProductList: [],
    allMonthlyStockAnalysisReportByCityList: [],
    monthlyStockAnalysisReportList: [],
    shopList: [],
    productList: [],
    categoryList: [],
    cityList: [],
    clonequeryParams: new Object(),
    filterCategory: "ALL",
  }),
  watch: {
    pagination: {
      handler() {
        this.getMonthlyStockAnalysisReportByCity();
      },
      deep: true,
    },
    productPagination: {
      handler() {
        this.getProductList();
      },
      deep: true,
    },
  },
  created() {
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shopId;
    }
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    if (this.$route.query.shopId) {
      this.queryParams.size = this.$route.query.shopId;
    }
    this.getCategoriesByStatus();
    this.onSearch();
    //this.getMonthlyStockAnalysisReportByCity();
    this.decimalFormat = commonService.formatdecimal();
    this.getAllCity();
    this.getAllShop();
  },
  methods: {
    getMonthlyStockAnalysisReportByCity: function () {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockService
        .getMonthlyStockAnalysisReportByCity(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.monthlyStockAnalysisReportList =
              res.data.monthlyStockAnalysisReports;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getCategoriesByStatus() {
      return categoryService
        .getCategoriesByStatus("ACTIVE")
        .then((res) => {
          this.categoryList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    showProducts: function () {
      this.productQueryParams.code = "";
      this.productQueryParams.name = "";
      this.productQueryParams.brandName = "";
      this.productQueryParams.categoryName = "";
      this.productQueryParams.productGroupName = "";
      this.selectedProductList = [];
      this.queryParams.productIds = [];
      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },
    getProductList: function () {
      this.showListLoading = true;
      let order = this.productPagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.productQueryParams,
          this.productPagination.page,
          this.productPagination.rowsPerPage,
          this.productPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productList = res.data.productList;
            this.productTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    toggleAllProduct: function () {
      if (this.selectedProductList.length) {
        this.selectedProductList = [];
      } else {
        this.selectedProductList = this.productList.slice();
      }
    },
    setProduct: function () {
      if (this.selectedProductList.length) {
        this.queryParams.productIds = [];
        this.selectedProductList.forEach((element) => {
          if (!this.queryParams.productIds.includes(element.id))
            this.queryParams.productIds.push(element.id);
        });
      }
      this.showProductListDialog = !this.showProductListDialog;
    },
    onSearchProduct: function () {
      this.productQueryParams.page = this.productPagination.page;
      this.productQueryParams.size = this.productPagination.rowsPerPage;
      this.getProductList();
    },
    onSearch: function () {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "monthly-stock-analysis-report-by-city",
        query: this.queryParams,
      });
      this.getMonthlyStockAnalysisReportByCity();
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
      if (this.queryParams.categoryIds.length > 0) {
        this.filterCategory = "";
        for (var i = 0; i < this.queryParams.categoryIds.length; i++) {
          let category = commonService.search(
            "id",
            this.queryParams.categoryIds[i],
            this.categoryList
          );
          this.filterCategory += category.name + ", ";
        }
      } else {
        this.filterCategory = "ALL";
      }
    },
    getAllCity: function () {
      cityService
        .getAllCity()
        .then((res) => {
          this.cityList = res.data.cityList;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    printAllMonthlyAnalysisReportByCity: function (divName) {
      this.printAllButtonLoading = true;
      stockService
        .getAllMonthlyStockAnalysisReportByCity(this.clonequeryParams)
        .then((res) => {
          if (res.data) {
            this.allMonthlyStockAnalysisReportByCityList =
              res.data.monthlyStockAnalysisReports;
            this.grandTotalQty = res.data.grandTotalQty;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
  },
};
</script>